import { Alert } from "@ui/Alert";
import { Show } from "solid-js";
import { VideoPanelContent } from "~/modules/shared/chat/components/VideoPanelContent/VideoPanelContent";
import "~/modules/askgvt/public-profile/components/AskPageSidePane.css";
import type { AskPageBoardClipPlayback } from "../useAskPageBoardClipPlayback";

type Props = {
	playback: AskPageBoardClipPlayback;
	showAddToBoardButton: boolean;
};

export const AskPageBoardClipPane = (props: Props) => {
	const playback = () => props.playback;
	const panelOpen = () =>
		playback().isOpen() &&
		playback().videoIndex() !== undefined &&
		(playback().videoEvidence()?.length ?? 0) > 0;

	return (
		<Show when={panelOpen() || playback().error() != null}>
			<aside class="ask-page-side-pane" aria-label="Board clips">
				<Show when={playback().error() && !panelOpen()}>
					<Alert variant="error">{playback().error()}</Alert>
				</Show>
				<Show when={panelOpen()}>
					<VideoPanelContent
						class="ask-page-side-pane__content"
						videoIndex={playback().videoIndex() ?? 0}
						videoEvidence={playback().videoEvidence() ?? []}
						boardId={playback().activeBoardId()}
						onClose={playback().close}
						onVideoIndexChange={playback().setActiveVideoIndex}
						showAddToBoardButton={props.showAddToBoardButton}
						autoPlay={false}
					/>
				</Show>
			</aside>
		</Show>
	);
};
